import { connect } from "react-redux";
import { change_sheet } from "../../actions/questionActions";

const Banner = ({ change_sheet }) => {
  return (
    <div style={{ marginTop: "10px" }} className="d-flex justify-content-start">
      <button className="btn btn-dark mr-2 font-weight-bold" onClick={() => change_sheet("questions")}>
        Sheet 1
      </button>
      <button
        className="btn btn-dark mr-2 font-weight-bold"
        onClick={() => {
          change_sheet("questions2");
        }}
      >
        Sheet 2
      </button>
      <a href="https://graphcase.netlify.app/" target="_blank" rel="noreferrer">
        <button className="btn btn-primary font-weight-bold">Graph Case</button>
      </a>
    </div>
  );
};

export default connect(null, { change_sheet })(Banner);
